import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { withLatestFrom, map } from 'rxjs/operators';
import { Actions } from '../../actions';
import AppState from '../../state';
import { CreateOnboardingSuccess } from '../action-creators';
import { CREATE_ONBOARDING_SUCCESS } from '../actions';
import { CreateArtist } from '../../artist/action-creators';

export const onboardingCreatedEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateOnboardingSuccess>(CREATE_ONBOARDING_SUCCESS),
    withLatestFrom(state$),
    map(([action]) => {
      // if (action.onboarding.paymentRequired) {
      //   return push(`/payment/upgrade-artist/${action.onboarding.id}`);
      // }
      return new CreateArtist(action.onboarding.artist);
    })
  );
